<div class="form-section group mb-3">
  <div class="form-group">
    <label class="form-label">{{ title }}</label>
    <div class="add-group">
      <input type="text" class="form-control" [placeholder]="title" [(ngModel)]="formValue" />
      <button class="btn btn-green" (click)="add()">إضافة</button>
    </div>
  </div>

  @if(tableItems.length > 0) {
  <div class="table-responsive">
    <table id="order-table" class="table table-striped">
      <thead>
        <tr>
          <th class="width-10">#</th>
          <th>{{ title }}</th>
          <th class="width-20">تفاعل</th>
        </tr>
      </thead>
      <tbody>
        @for(item of tableItems; let i = $index; track i) {
        <tr>
          <td>{{ item.index }}</td>

          <td>
            @if(!item.isEditing) {
            {{ item.value }}
            } @else {
            <input type="text" class="form-control" [(ngModel)]="item.value" />
            }
          </td>

          <td>
            <div class="configuration-actions">
              @if(!item.isEditing) {
              <button class="btn btn-custom-delete" (click)="edit(item)">
                <img src="assets/images/svg/edit-icon.svg" alt="edit" />
              </button>
              } @else {
              <button class="btn btn-custom-delete" (click)="save(item)">
                <img src="assets/images/svg/configration.svg" alt="save" />
              </button>
              }
              <button class="btn btn-custom-delete" (click)="delete(i)">
                <img src="assets/images/svg/DELETE1.svg" alt="delete" />
              </button>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
